import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { TransactionRq } from '../shared/transactionRq.model';
import { SetReportRq } from '../shared/setReportRq.model';
import { environment, environmentDEBUG, environmentDev, environmentDev04, environmentPERF, environmentPROD, environmentQA, environmentTT, environmentUAT ,environmentUAT06,environmentDev05,environmentDev06,environmentDev07 } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AppService {
  isBasicAloneDisplayed: boolean = false;
  currentStep: any = 0;
  screenEnclosurePrice: any = 0;
  selectedPackage: string = '';
  dogLiablityAnswer: boolean = false;

  selectedPolicyType: string = 'HO3';
  
  defaultDCJSON = {
    "Flags": {
      "QuoteNumber": "",
      "Account": "1",
      "AOI": "0",
      "Coverages": "1",
      "PackageType": "Enhanced"
    },
    "AccountDetails": {
      "Account": {
        "FirstName": "",
        "LastName": "",
        "BirthDate": "",
        "PrimaryPhone": "",
        "Email": "",
        "EffectiveDate": "",
        "BillClass": "",
        "WritingCompany": ""
      },
      "PropertyAddress": {
        "Address1": "",
        "Address2": "",
        "City": "",
        "ZipCode": "",
        "State": "",
        "InfutorSquareFeet": "",
        "InfutorYearBuilt": ""
      },
      "CoApplicant": {
        "FirstName": "",
        "LastName": "",
        "HomePhone": "",
        "BirthDate": "",
        "MaritalStatus":""
      },
      "AOInterest": {
        "Name": "",
        "Address1": "",
        "City": "",
        "ZipCode": "",
        "State": "",
        "LoanNumber": ""
      },
      "UnderwritingQuestions": {
        "isBusinessConducted": "No",
        "isHouseForSale": "No",
        "anyCoverageDeclinedCancelled": "No",
        "isPropertyDisrepair": "No",
        "isPropertyWithin300FtOfCommercialProp": "No"
      }
    },
    "RiskDetails": {
      "QuoteNumber": "",
      "LOBType": "HomeownersAdvantage",
      "Construction": "",
      "ExteriorWallType": "",
      "FoundationType": "",
      "RoofGeometry": "Hip",
      "RoofType": "",
      "CarportsPoolCagesLimit": "0",
      "CoverageDogLiability": "0",
      "IdentityFraudExpenseCoverage": "0",
      "EquipmentBreakdown": "0",
      "RoofConditionScore": "5",
      "NumberofStories": "",
      "NumberOfChildren": "0"
    }
  };

  DCJSON: any;
  env: any = this.getEnvironment();

  constructor(private http: HttpClient) {
    this.DCJSON = this.defaultDCJSON;
  }

   resetDCJSON() {
   this.DCJSON = JSON.parse(JSON.stringify(this.defaultDCJSON));
    if (this.selectedPolicyType === 'HO6') {
        this.DCJSON.RiskDetails.LOBType = 'HomeownersAdvantage6';
      } else if (this.selectedPolicyType === 'DP3') {
        this.DCJSON.RiskDetails.LOBType = 'AdvantageDwellingFireDp3';
      } else if (this.selectedPolicyType === 'DP1') {
        this.DCJSON.RiskDetails.LOBType = 'AdvantageDwellingFireDp1';
      } else {
        this.DCJSON.RiskDetails.LOBType = 'HomeownersAdvantage'; 
  }
  }
    setPolicyType(policyType: 'HO3' | 'HO6' | 'DP3' | 'DP1') {
      this.selectedPolicyType = policyType;

      if (policyType === 'HO6') {
        this.DCJSON.RiskDetails.LOBType = 'HomeownersAdvantage6';
      } else if (policyType === 'DP3') {
        this.DCJSON.RiskDetails.LOBType = 'AdvantageDwellingFireDp3';
      } else if (policyType === 'DP1') {
        this.DCJSON.RiskDetails.LOBType = 'AdvantageDwellingFireDp1';
      } else {
        this.DCJSON.RiskDetails.LOBType = 'HomeownersAdvantage';
      }
  }

  getEnvironment() {
    let domain = this.domain_from_url(window.location.origin);
    if (domain == 'nsurehub.com') {
      return environmentPROD;
    }
    else if (domain == 'debugnsurehub.preprodmiddleware.safepointdc.com') {
      return environmentDEBUG;
    }
    else if (domain == 'perfnsurehub.preprodmiddleware.safepointdc.com') {
      return environmentPERF;
    }
    else if (domain == 'uat.nsurehub.com') {
      return environmentUAT;
    }
    else if(domain == 'dev04nsurehub.middleware.safepointdc.com'){
      return environmentDev04
    }
    else if (domain == 'ttnsurehub.middleware.safepointdc.com') {
      return environmentTT;
    }
    else if (domain == 'qansurehub.middleware.safepointdc.com') {
      return environmentQA;
    }
    else if (domain == 'ondemanddev.nsurehub.com') {
      return environmentDev;
    }
    else if(domain=='uat2nsurehub.preprodmiddleware.safepointdc.com'){
      return environmentUAT06;
    }
    else if(domain=='dev05nsurehub.middleware.safepointdc.com'){
      return environmentDev05;
    }
    else if(domain=='dev06nsurehub.middleware.safepointdc.com'){
      return environmentDev06;
    }
    else if(domain=='dev07nsurehub.middleware.safepointdc.com'){
      return environmentDev07;
    }
    else {
      return environment;
    }
  }
  domain_from_url(url: any) {
    var result
    var match
    if (match = url.match(/^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/im)) {
      result = match[1];
    }
    return result
  }

  api: string = this.env.baseUrl;

  getAddressByLatLang(lat: any, lang: any) {
    return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lang}&key=${atob(this.env.googleKEY)}`);
  }
  getLatLangByAddress(address: any) {
    return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${atob(this.env.googleKEY)}`);
  }
  dataFinder(d_address: any, d_city: any, d_state: any, d_zip: any) {
    let headers = new HttpHeaders();
    headers = headers.set('x-versium-api-key', this.env.versiumAPIKEY);

    return this.http.get(`${this.env.datafinderURL}/demographic?output[]=demographic&address=${d_address}&city=${d_city}&state=${d_state}&zip=${d_zip}`, { headers: headers });
  }
  dataFinderContact(d_address: any, d_city: any, d_state: any, d_zip: any) {
    let headers = new HttpHeaders();
    headers = headers.set('x-versium-api-key', this.env.versiumAPIKEY);

    return this.http.get(`${this.env.datafinderURL}/contact?output[]=email&output[]=phone&address=${d_address}&city=${d_city}&state=${d_state}&zip=${d_zip}`, { headers: headers });
  }

  createQuote(data: any): any {
    localStorage.setItem("DCJSONLOCAL", JSON.stringify(data));
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', "application/json");
    return this.http.post(this.env.dcAPI + 'CreateQuote', data, { headers: headers });
  }
  updateQuote(data: any): any {
    localStorage.setItem("DCJSONLOCAL", JSON.stringify(data));
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', "application/json");
    data.Flags.PackageType = this.selectedPackage;
    return this.http.post(this.env.dcAPI + 'UpdateQuote', data, { headers: headers });
  }
  bindQuote(data: any): any {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', "application/json");
    return this.http.post(this.env.dcAPI + `BindQuote?QuoteNumber=${data.quoteNumber}&IsMortgage=${data.isMortgage}&State=${data.state}`, {}, { headers: headers });
  }
  loadMapJs() {
    let gapi = atob(this.env.googleKEY);
    const node = document.createElement('script');
    node.src = `https://maps.googleapis.com/maps/api/js?key=${gapi}&libraries=places`;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  getGICToken() {
    let apiUrl = `${this.env.gicAPI}/auth/login?username=${atob(this.env.gicUserName)}&password=${atob(this.env.gicPassword)}`;
    return new Promise((resolve, reject) => {
      this.http.post(apiUrl,{}).subscribe((res: any) => {
        if (res && res.token) {
          localStorage.setItem("GIC_TOKEN", res.token);
          localStorage.setItem("GIC_TOKEN_EXPIRY", res['date-expiration']);
          resolve(res.token);
        } else {
          reject(null);
        }
      }, (error: any) => {
        reject(null);
      });
    });
  }
  gicAPI(token: any, lat: any, long: any) {
    //get token
    return this.http.get(`${this.env.gicAPI}/property/extract?search_radius=10&wkt=POINT(${long} ${lat})&token=${token}`);
  }
  gicAPIWithrequest(token: any, lat: any, long: any) {
    //get token
    return this.http.get(`${this.env.gicAPI}/property/extract?wkt=POINT(${long} ${lat})&token=${token}`);
  }
  checkIfAOInterestEmpty() {
    let empty = true;
    if (this.DCJSON.AccountDetails.AOInterest) {
      for (const [key, value] of Object.entries(this.DCJSON.AccountDetails.AOInterest)) {
        if (value != "") {
          empty = false;
          break;
        }
      }
    }

    return empty;
  }
  checkIfCoApplicantEmpty() {
    let empty = true;
    if (this.DCJSON.AccountDetails.CoApplicant) {
      for (const [key, value] of Object.entries(this.DCJSON.AccountDetails.CoApplicant)) {
        if (value != "") {
          empty = false;
          break;
        }
      }
    }
    return empty;
  }


  validatePayment(transactionRqObj: TransactionRq): any {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', "application/json");
    return this.http.post(this.env.dcAPI + `BindQuote?QuoteNumber=${transactionRqObj.QuoteNumber}&TransactionId=${transactionRqObj.TransactionId}&EmailId=${transactionRqObj.EmailId}&IsMortgage=${transactionRqObj.IsMortgage == '1' ? true : false}&State=${transactionRqObj.State}`, {}, { headers: headers });
  }

  setReport(message: string): any {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', "application/json");
    let setReportRq: SetReportRq = new SetReportRq;
    setReportRq.address = this.DCJSON.AccountDetails.PropertyAddress["OriginalAddress"];
    setReportRq.description = message;
    setReportRq.Name = this.DCJSON.AccountDetails.Account["FirstName"] + " " + this.DCJSON.AccountDetails.Account["LastName"];
    setReportRq.Email = this.DCJSON.AccountDetails.Account["Email"];
    setReportRq.EffectiveDate = this.DCJSON.AccountDetails.Account["EffectiveDate"];
    setReportRq.PhoneNumber = this.DCJSON.AccountDetails.Account["PrimaryPhone"];
    setReportRq.quotePolicyNumber = JSON.parse(localStorage.getItem('DC_RESPONSE') || '').quoteNumber;
    return this.http.post(this.env.dcAPI + `SetReport`, setReportRq, { headers: headers });
  }

  // postSignature(data:any){
  //   return this.http.post(environment.signatureUrl + `PostSignature?code=${environment.signatureAccessCode}`, data);
  // }

  //Added state string
 postSubscriberAgreement(PolicyNumber:any, state: string){
    return this.http.post(this.env.dcAPI + `PostSignature?PolicyNumber=${PolicyNumber}&State=${state}`, {});
 
  }

  uploadSubscriberAgreement(data: any) {
    return this.http.post(this.env.dcAPI + 'UploadSubscriberAgreement', data);
  }

  heartlandRedirect(url:any,payload:any){
    return this.http.post(url,payload);
  }
}
